import { STORAGE_KEYS } from "@/lib/constants"

export type CookieConsent = "accepted" | "declined" | null

/**
 * Custom event fired whenever the user accepts or declines cookies, so the
 * Analytics component can react in the same session without a page reload.
 */
export const CONSENT_CHANGED_EVENT = "glossgo:cookie-consent-changed"

export function getCookieConsent(): CookieConsent {
  if (typeof window === "undefined") return null
  const value = window.localStorage.getItem(STORAGE_KEYS.cookieConsent)
  return value === "accepted" || value === "declined" ? value : null
}

export function setCookieConsent(value: Exclude<CookieConsent, null>): void {
  if (typeof window === "undefined") return
  window.localStorage.setItem(STORAGE_KEYS.cookieConsent, value)
  window.dispatchEvent(
    new CustomEvent<CookieConsent>(CONSENT_CHANGED_EVENT, { detail: value })
  )
}
